import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import AvatarEditor from 'flarum/forum/components/AvatarEditor';
import Button from 'flarum/common/components/Button';
import AvatarFocusModal from './components/AvatarFocusModal';
function featureActive(user) {
  var _user$canSetAvatarFoc;
  return !!app.forum.attribute('ziven-profile-cover.avatar_focus') && !!(user != null && (_user$canSetAvatarFoc = user.canSetAvatarFocus) != null && _user$canSetAvatarFoc.call(user));
}

/**
 * When avatar focal-point mode is enabled:
 *
 * 1. avatar uploads are routed through Cover Studio's endpoint so the original
 *    image is preserved in the media manager (core's endpoint discards it),
 * 2. an "Adjust position" entry appears in the avatar dropdown, which re-crops
 *    the avatar server-side from that original — no re-upload needed,
 * 3. for users WITHOUT an avatar, clicking the avatar opens our modal (with
 *    upload + "choose from My Media") instead of core's bare file picker.
 */
export default function extendAvatarEditor() {
  extend(AvatarEditor.prototype, 'controlItems', function (items) {
    const user = this.attrs.user;

    // Shown even without a stored original: the modal itself offers uploading
    // a new image or picking one from the media manager.
    if (!featureActive(user)) return;
    items.add('ziven-profile-cover-focus', m(Button, {
      icon: "fas fa-crosshairs",
      onclick: () => app.modal.show(AvatarFocusModal, {
        user
      })
    }, app.translator.trans('ziven-profile-cover.forum.avatar.adjust_button')), -5);
  });

  // Route EVERY core path into the file picker through our modal instead:
  // the dropdown "Upload" item calls openPicker directly, and for users
  // without an avatar core's quickUpload also lands in openPicker. The modal
  // offers uploading AND picking from the media manager, followed directly by
  // positioning — so the positioning step can never be skipped accidentally.
  override(AvatarEditor.prototype, 'openPicker', function (original) {
    const user = this.attrs.user;
    if (!featureActive(user)) {
      return original();
    }
    app.modal.show(AvatarFocusModal, {
      user
    });
  });
  override(AvatarEditor.prototype, 'upload', function (original, file) {
    const user = this.attrs.user;
    if (!featureActive(user)) {
      return original(file);
    }
    const self = this;
    if (self.loading) return;
    const body = new FormData();
    body.append('avatar', file);
    body.append('focusX', '50');
    body.append('focusY', '50');
    self.loading = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: "".concat(app.forum.attribute('apiUrl'), "/users/").concat(user.id(), "/ziven-profile-cover/avatar"),
      serialize: raw => raw,
      body
    }).then(self.success.bind(self), self.failure.bind(self));
  });
}